(function () {
  'use strict';

  const videoBlocks = document.querySelectorAll('.org-video-block');

  if(videoBlocks){
    videoBlocks.forEach((videoBlock) => {
      const playbutton = videoBlock.querySelector('.atm-play');
      const thumbnail = videoBlock.querySelector('.thumbnail');
      const video = videoBlock.querySelector('.atm-video iframe');

      playbutton.addEventListener('click', () => {
        video.src = video.src + "?autoplay=1";
        thumbnail.classList.add('hidden');
      });
    })
  }
})();
